<template>
  <el-row type="flex" style="min-height: 100%;">
    <el-col :span="20">
      <el-menu
        class="el-menu-vertical"
        :default-active="$route.name"
        router
        :collapse="isCollapse"
        :style="isCollapse ? 'width: 60px' : 'width: 220px'"
      >
        <template v-for="item in menu">
          <el-submenu :index="item.index" :key="item.index" v-if="item.subs">
            <template #title
              ><i :class="item.icon"></i
              ><span slot="title">{{ item.title }}</span></template
            >
            <el-menu-item
              v-for="subItem in item.subs"
              :key="subItem.index"
              :index="subItem.index"
              :route="`/${subItem.index}`"
              ><i :class="subItem.icon"></i
              ><span slot="title">{{ subItem.title }}</span></el-menu-item
            >
          </el-submenu>
          <el-menu-item
            :index="item.index"
            :key="item.index"
            :route="`/${item.index}`"
            v-else
          >
            <i :class="item.icon"></i><span slot="title">{{ item.title }}</span>
          </el-menu-item>
        </template>
      </el-menu>
    </el-col>
    <el-col :offset="2">
      <div
        class="btn pink"
        @click="setCollapse(!isCollapse)"
        style="height:80%;"
      >
        <el-tooltip
          class="item"
          effect="dark"
          content="Collapse Menu"
          placement="bottom"
          style="position:relative; top:50%;"
        >
          <i
            class="fas"
            :class="isCollapse ? 'fa-angle-right' : 'fa-angle-left'"
          ></i>
        </el-tooltip>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {};
  },

  computed: {
    ...mapState({
      isCollapse: (state) => state.isSidebarCollapse,
      userInfo: (state) => state.user.userInfo,
    }),
    menu() {
      let res = [
        {
          icon: "fas fa-user-friends",
          index: "backstage_creator_management",
          title: "Creator Management",
        },
      ];
      return res;
    },
  },
  methods: {
    ...mapMutations({
      setCollapse: "setSidebarCollapse",
    }),
  },
};
</script>
